import _asyncToGenerator from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
export var getCleanMapApi = function getCleanMapApi(json) {
  var cleanMapApi = [];
  if (json && json.length > 0) {
    json.forEach(function (each) {
      var mapObj = {};
      mapObj['displayLat'] = each.yextDisplayCoordinate.latitude;
      mapObj['displayLng'] = each.yextDisplayCoordinate.longitude;
      mapObj['routableLat'] = each.yextRoutableCoordinate.latitude;
      mapObj['routableLng'] = each.yextRoutableCoordinate.longitude;
      mapObj['name'] = each.name;
      mapObj['businessType'] = each.c_businessType;
      mapObj['address'] = each.address;
      mapObj['googlePlaceId'] = each.googlePlaceId;
      mapObj['websitePhone'] = each.c_websitePhone;
      mapObj['mainPhone'] = each.mainPhone;
      mapObj['meta'] = each.meta;
      mapObj['websiteUrl'] = each.websiteUrl;
      cleanMapApi.push(mapObj);
    });
  }
  return cleanMapApi;
};
export var getCleanMapApiUpdated = function getCleanMapApiUpdated(json) {
  var cleanMapApi = [];
  if (json && json.entities && json.entities.length > 0) {
    json.entities.forEach(function (each) {
      var mapObj = {};
      mapObj['address'] = each.address;
      mapObj['name'] = each.name;
      mapObj['c_googleMyBusinessCID'] = each.c_googleMyBusinessCID;
      mapObj['c_textPhone'] = each.c_textPhone;
      mapObj['c_websitePhone'] = each.c_websitePhone;
      mapObj['fax'] = each.fax;
      mapObj['mainPhone'] = each.mainPhone;
      mapObj['reservationUrl'] = each.reservationUrl;
      mapObj['websiteUrl'] = each.websiteUrl;
      mapObj['yextDisplayCoordinate'] = each.yextDisplayCoordinate;
      mapObj['yextRoutableCoordinate'] = each.yextRoutableCoordinate;
      cleanMapApi.push(mapObj);
    });
  }
  json['entities'] = cleanMapApi;
  return json;
};
export var getOrderedLocations = function getOrderedLocations(filteredApiData, sortType) {
  // If we are not calculating distances, the list will be in alphabetical order.
  return filteredApiData.sort(function (a, b) {
    return a.name > b.name && sortType ? 1 : -1;
  });
};

// this function seems unnecessary as it just points to getBlobData
export var useYextFetchGoogleMaps = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return getBlobData();
          case 3:
            return _context.abrupt("return", _context.sent);
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", []);
          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 6]]);
  }));
  return function useYextFetchGoogleMaps() {
    return _ref.apply(this, arguments);
  };
}();
export var getBlobData = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var urlBlob, data, resp;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            urlBlob = "https://codesguat.blob.core.windows.net/yextdata/yextLocationData.json?V=".concat(Math.random());
            _context2.prev = 1;
            _context2.next = 4;
            return fetch(urlBlob);
          case 4:
            data = _context2.sent;
            _context2.next = 7;
            return data.json();
          case 7:
            resp = _context2.sent;
            return _context2.abrupt("return", resp.data);
          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", []);
          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 11]]);
  }));
  return function getBlobData() {
    return _ref2.apply(this, arguments);
  };
}();